/**
 * Turn our internal CAD job_id (which starts with `tripo_<hex>` for
 * historical / engine-correlation reasons) into a user-facing slug for
 * download filenames.
 *
 * MUST stay in sync with the backend's `_download_slug()` in
 * routers/tripo.py so the browser and server produce identical filenames.
 *
 * The browser's <a download="..."> attribute takes precedence over the
 * server's Content-Disposition header, so the frontend must strip the
 * prefix itself — otherwise the user sees `facetra_3d_tripo_abc.stl`
 * even though the server responded with a clean `facetra_3d_abc.stl`.
 */
export function cadDownloadSlug(jobId) {
  if (!jobId) return "cad";
  return jobId.startsWith("tripo_") ? jobId.slice(6) || "cad" : jobId;
}
